$(document).ready(function() {
    let headerLogo = $('.header-logo--text').html();
    let headerPath = $('.header-path--text').find('a').text();
    $('.header-logo').html(headerLogo);
    $('.collection-item').each(function () {
        let thisText = $(this).find('a').text().trim().replace(/\s+/g, ' ');
        if (headerPath == thisText) {
            $(this).find('a').addClass('on');
        }

        if($(this).find('a').hasClass('on')){
            $('.collection-current span').text(thisText);
        }
    });
});

// 피씨버전 메뉴 클릭 이벤트
// $('.nav-depth--1').on('click', function () {
//     let thisTitle = $(this).text().toLowerCase();
//     $('header').addClass('active');
//     $('.nav-depth--1').removeClass('on');
//     $(this).addClass('on');
//     $('.product-header-logo').css('display', 'none'); // header pannel 열린 상태에선 헤더 로고 숨김
//     $('.main-hero-logo').css('display', 'none'); 
//     $('.header-panel').fadeIn();
//     $('.header-panel').find('img').fadeOut(100);
//     setTimeout(function(){
//         $('.header-panel').find(`img.hero-${thisTitle}`).fadeIn(100);
//     }, 150);
//     $('.jaden-cho').addClass('sp');
// });

$('.nav-depth--1').on('click', function () {
    let thisTitle = $(this).text().trim().toLowerCase();
    console.log('thisTitle', thisTitle);

    if (thisTitle === 'projects' || thisTitle === 'collection') { // 2026-09-21 'PROJECTS' 메뉴일 때 패널 안 열림
        return true;
    }

    $('header').addClass('active');
    $('.nav-depth--1').removeClass('on');
    $(this).addClass('on');
    $('.product-header-logo').css('display', 'none');
    $('.main-hero-logo').css('display', 'none'); 
    $('.header-panel').fadeIn();
    $('.header-panel').find('img').fadeOut(100);

    setTimeout(function(){
        $('.header-panel').find(`img.hero-${thisTitle}`).fadeIn(100);
    }, 150);

    $('.jaden-cho').addClass('sp');
});

$('.nav-depth--2 .nav-depth-item').on('click', function (e) {
    const parent1 = $(this).closest('.nav-depth--2').prev('.nav-depth--1');
    const parent1Text = parent1.text().toLowerCase();
    const currentTitle = $(this).text();    

    if (currentTitle.includes('READY TO WEAR')) {
        e.preventDefault(); 
    }
    
    $('.nav-depth--2 > .nav-depth-inner > .nav-depth-item').removeClass('on');
    $('.nav-depth--3').removeClass('on').css('display', 'none');

    $(this).addClass('on');
    
    const depth3Menu = $(this).find('.nav-depth--3');
    
    if ($(this).hasClass('on')) {
        $('.nav-depth--2 a').css('color', '#8B8B8B'); 
        $(this).children('a').css('color', '#000'); 
        depth3Menu.addClass('on').css('display', 'block'); 
    }
});

$('.nav-depth--3 > .nav-depth-item > a').on('click', function (e) {
    e.stopPropagation(); // 3depth 클릭 시 기본 동작 허용
});

$('.close-btn--header-panel').on('click', function () {
    $('header').removeClass('active');
    $('.nav-depth--1').removeClass('on');
    $('.product-header-logo').css('display', 'block');
    $('.main-hero-logo').css('display', 'block'); 
    $('.header-panel').fadeOut();
    $('.header-panel').find('img').fadeOut();
    $('.jaden-cho').removeClass('sp');
});


// 모바일 버전 메뉴 클릭 이벤트
$('.m-nav-btn').on('click', function () {
    const isOpen = $(this).hasClass('on');

    if (!isOpen) {
        $(this).addClass('on');
        $('header.header').addClass('m-nav-on');
        $('header.header .page-view--products').css('position', 'fixed');

        $('.header-panel--m').css('display', 'block');
        $('.panel[data-depth="1"]').css({
            'left': '0%',
            'display': 'block'
        });

        $('.jaden-cho').addClass('sp');

        $('.panel[data-depth="2"], .panel[data-depth="3"]').css({
            'left': '100%',
            'display': 'none'
        });

    } else {
        $(this).removeClass('on');
        $('header.header').removeClass('m-nav-on');
        $('header.header .page-view--products').css('position', 'absolute');
        $('.header-panel--m').css('display', 'none');
        $('.panel[data-depth="1"]').css({
            'left': '100%',
            'display': 'none'
        });

        $('.jaden-cho').removeClass('sp');

        $('.panel').css({
            'left': '100%',
            'display': 'none'
        });
    }
});



$('.m-nav-depth--1').on('click', function () {
    const index = $(this).data('index');
    $('.panel[data-depth="1"]').animate({ left: '-100%', opacity: 0 }, 450, function () {
        $(this).hide().css({ opacity: 1 });
    });

    $(`.panel[data-depth="2"][data-parent-index="${index}"]`)
        .css({ display: 'block', left: '100%', opacity: 0 })
        .animate({ left: '0%', opacity: 1 }, 450);

    $('header.header').addClass('m-depth-on');
});

$('.m-nav-depth--2').on('click', function () {
    const index = $(this).data('index');
    $('.panel[data-depth="2"]').animate({ left: '-100%', opacity: 0 }, 450, function () {
        $(this).hide().css({ opacity: 1 });
    });

    $(`.panel[data-depth="3"][data-parent-index="${index}"]`)
        .css({ display: 'block', left: '100%', opacity: 0 })
        .animate({ left: '0%', opacity: 1 }, 450);

    $('header.header').addClass('m-depth-on');
});

$('.back-btn').on('click', function () {
    const $currentPanel = $(this).closest('.panel');
    const currentDepth = $(this).closest('.panel').data('depth'); 
    const parentDepth = currentDepth - 1; 

    if (parentDepth === 1) {
        $('header.header').removeClass('m-depth-on');
    }

    if (currentDepth === 3) {     
        const $shop2DepthPanel = $(`.panel[data-depth="2"][data-parent-index="3"]`);
        
        $shop2DepthPanel.css('left', '-100%') 
            .fadeIn(0) 
            .animate({ left: '0%' }, 450);  

        $currentPanel.animate({ left: '100%', opacity: 0 }, 450, function () {
            $currentPanel.hide();
        });
    }
    else {
        $('.panel').each(function () {
            const panelDepth = $(this).data('depth');
            
            if (panelDepth === parentDepth) {
                $(this).css('left', '-100%')  
                    .fadeIn(0) 
                    .animate({ left: '0%', opacity: 1 }, 450); 
            } else {
                $(this).hide(); 
            }
        });
    }
});

$('.close-btn').on('click', function () {
    $('.header-panel--m').css('display', 'none');
    $('header.header').removeClass('m-nav-on m-depth-on');
    $('.jaden-cho').removeClass('sp');

    $('.panel').css({
        'left': '100%',   
        'display': 'none' 
    });
});



$('.collection-current').on('click', function () {
    $('.header-depth--m').toggleClass('on');
    if($('.header-depth--m').hasClass('on')){
        $('header.header').addClass('m-depth-on');
        $('.dim').show();
        $('.jaden-cho').addClass('sp');
    }else{
        $('header.header').removeClass('m-depth-on');
        $('.dim').hide();
        $('.jaden-cho').removeClass('sp');
    }
});

$('.m-nav-link').on('click', function () {
  console.log('ddd');
    const selectedMenuTitle = $(this).text().trim(); 
    $('.header-inner--m .collection-current').text(selectedMenuTitle);
    
});

// 상품 상세페이지 버튼 이벤트
let target; 

$(document).on('click', '.pmi-btn', function () {
    target = $(this).data('target'); 

    $('.pmi-panel').removeClass('show'); 
    $(`.pmi-panel[data-panel="${target}"]`).addClass('show'); 
    $(`.pmi-dim[data-dim="${target}"]`).show(); 
});

$('.pmi-close-btn').on('click', function () {
    $(`.pmi-panel[data-panel="${target}"]`).removeClass('show'); 
    $(`.pmi-dim[data-dim="${target}"]`).hide(); 
});

$('.pmi-dim').on('click', function () {
    $('.pmi-panel').removeClass('show'); 
    $(this).hide(); 
});

$('.dim').on('click', function(){
    if($('.header-depth--m').hasClass('on')){
        $('.header-depth--m').removeClass('on');
        $('header.header').removeClass('m-depth-on');
    }
    $('.dim').hide();
    $('.jaden-cho').removeClass('sp');
});


// 장바구니 페이지 내의 'BACK TO PAGE' 버튼 이벤트
document.addEventListener('DOMContentLoaded', function () {
    const goBackButton = document.getElementById('go-back-button');
    if (goBackButton) {
      goBackButton.addEventListener('click', function (e) {
        e.preventDefault(); // 기본 페이지 이동 동작 방지
        window.history.back(); // 브라우저의 이전 페이지로 이동
      });
    } 
  });
  
// ABOUT > JADEN CHO 스크롤 이벤트
$(document).ready(function () {
    const $images = $('.about-image');
    let lastScrollTop = 0;
  
    $images.first().addClass('active');
  
    $(window).on('scroll', function () {
        let scrollTop = $(window).scrollTop();
        let index = Math.floor(scrollTop / 80) % $images.length; // 200px마다 이미지 변경
        
        if (scrollTop > lastScrollTop) { 
            $images.removeClass('active');
            $images.eq(index).addClass('active');
        } else { 
            $images.removeClass('active');
            $images.eq(index).addClass('active');
        }
        
        lastScrollTop = scrollTop;
    });
});

// ABOUT > ARCHIVE 스크롤 이벤트
$(document).ready(function () {
    const $textItems = $('.text-item');
    const $images = $('.portrait-image');
    const $textContainer = $('.portrait-text');

   $images.first().addClass('active');
  
    $textContainer.on('scroll', function () {
      const containerTop = $textContainer.offset().top;
      console.log('$images.first()',$images.first())
      
      $textItems.each(function () {
          const itemTop = $(this).offset().top;
  
        if (itemTop <= containerTop && itemTop + $(this).outerHeight() > containerTop) {
          const target = $(this).find('span').text().trim(); 
          $images.removeClass('active'); 
  
          $images.each(function () {
            if ($(this).data('target') === target) {
              $(this).addClass('active'); 
            }
          });
          return false; 
        }
      });
    });
  });


// GARDEN TOWER 국/영문 토글
const $langBtnJadenCho = $('#langButtonJadenCho');
const jadenChoKoText = $('.store-inner.store-description .description.ko');
const jadenChoEnText = $('.store-inner.store-description .description.en');

$langBtnJadenCho.on('click', function (e) {
  const jadenChoIsKorean = jadenChoKoText.css('display') !== 'none';

  if(jadenChoIsKorean) {
    $langBtnJadenCho.text('EN');
    jadenChoKoText.css('display', 'none');
    jadenChoEnText.css('display', 'block');
  } else {
    $langBtnJadenCho.text('KR');
    jadenChoKoText.css('display', 'block');
    jadenChoEnText.css('display', 'none');
  }
})


// PROJECTS 국/영문 토글
const $langBtn =  $('#langButton');
const koText =  $('.content-block.text .text-box.ko');
const enText =  $('.content-block.text .text-box.en');

$langBtn.on('click', function (e) {
  const isKorean = $('.content-block.text .text-box.ko').css('display') !== 'none';

  if(isKorean) {
    $langBtn.text('EN');
    koText.css('display', 'none');
    enText.css('display', 'block');
  } else {
    $langBtn.text('KR');
    koText.css('display', 'block');
    enText.css('display', 'none');
  }
})

// 상품 상세설명 국/영문 토글
const $productLangButton =  $('#productLangButton');
const productKoText =  $('.product-block.ko');
const productEnText =  $('.product-block.en');
const productKoSummary =  $('.product-summary.ko');
const productEnSummary =  $('.product-summary.en');


$productLangButton.on('click', function (e) {
  const isKorean = $('.product-block.ko').css('display') !== 'none';

  if(isKorean) {
    $productLangButton.text('EN');
    productKoText.css('display', 'none');
    productKoSummary.css('display', 'none');
    productEnText.css('display', 'block');
    productEnSummary.css('display', 'block');
   ;
  } else {
    $productLangButton.text('KR');
    productKoText.css('display', 'block');
    productKoSummary.css('display', 'block');
    productEnText.css('display', 'none');
    productEnSummary.css('display', 'none');

  }
})




